import { render, staticRenderFns } from "./TestItemFillbank.vue?vue&type=template&id=598ae798&scoped=true&"
import script from "./TestItemFillbank.vue?vue&type=script&lang=js&"
export * from "./TestItemFillbank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ae798",
  null
  
)

export default component.exports